module.exports = __webpack_public_path__ + "img/logo.bda2de7e.png";